const ELEMENT_COLORS = {
    Title: 'lightpink',
    Description: '#82f768',
    Date: '#89b8fa',
    Link: '#C0C0C0',
};
export const NOT_NEWS_MSG = 'This is not like news!';
export const EMPTY_ARRAY_MSG = 'Array is empty!';
export const CANNOT_SELECT_IMG_MSG = 'Cannot select image as news field!';
export const BAD_CONTAINER_PATH_MSG = 'Bad container path!';

let COLUMN_COUNT = 0;

/**
 * @param eventPathNodes [td, ..., document, Window]
 * @param bodyFromIframe Node <body...>...</body>
 *
 * @returns String 'div.g-page:nth-child(1) > ... > li:nth-child(1)'
 *
 * @throws Error
 */
export const getContainerCssSelector = (eventPathNodes, bodyFromIframe) => {
    const targetNodes = getTargetNodes(eventPathNodes);
    let targetNode = [...targetNodes].splice(-1, 1)[0];

    if('IMG' === targetNode.tagName) {
        throw new Error(CANNOT_SELECT_IMG_MSG);
    }

    const maxNewsCount = getMaxNewsCount(targetNodes, bodyFromIframe);

    let currentLevel = 0;
    while(20 > currentLevel) {
        ++currentLevel;

        let nodes = [...targetNodes];
        const fieldNodes = nodes.splice(-currentLevel, currentLevel);
        nodes.splice(-1, 1);

        if(!nodes.length || !fieldNodes.length) {
            break;
        }

        const cssSelector = getCssSelectorWithPositionsByNodes(nodes);
        const clearingCssSelector = clearPositionOfLastElement(cssSelector);
        const newsNodeList = bodyFromIframe.querySelectorAll(clearingCssSelector);
        if(!newsNodeList.length) {
            throw new Error(NOT_NEWS_MSG);
        }

        if(maxNewsCount === getNewsCount(newsNodeList, fieldNodes)) {
            if('TR' === fieldNodes[0].parentNode.parentNode.tagName) {  //kostil?
                continue;
            }
            //This var is probably the same as fieldNodes
            let newsNodeList = [...targetNodes];
            newsNodeList.splice(-currentLevel, currentLevel);

            return getCssSelectorWithPositionsByNodes(newsNodeList, true);
        }
    }

    throw new Error(NOT_NEWS_MSG);
};

/**
 * @param targetNodes Node[] [section#site--main.main-content--bg-color.main-content--overflow, ..., tr, td.date]
 * @param bodyFromIframe Node <body...>...</body>
 *
 * @returns Number
 */
export const getMaxNewsCount = (targetNodes, bodyFromIframe) => {
    let maxNewsCount = 0;

    let currentLevel = 0;
    while(20 > currentLevel) {
        ++currentLevel;

        let nodes = [...targetNodes];
        //TODO: refactor (need to break up into a mutator - not a mutator)
        const fieldNodes = nodes.splice(-currentLevel, currentLevel);
        nodes.splice(-1, 1);

        if(!nodes.length || !fieldNodes.length) {
            break;
        }

        const cssSelector = getCssSelectorWithPositionsByNodes(nodes);
        const clearingCssSelector = clearPositionOfLastElement(cssSelector);
        const newsNodeList = bodyFromIframe.querySelectorAll(clearingCssSelector);

        if(!newsNodeList.length) {
            throw new Error(NOT_NEWS_MSG);
        }

        const newsCount = getNewsCount(newsNodeList, fieldNodes);

        if(maxNewsCount < newsCount) {
            maxNewsCount = newsCount;
        }
    }

    return maxNewsCount;
};

/**
 * @param eventPathNodes Node[] [a.link, ..., div.g-page, body.page-index, html.is_desktop, document, Window]
 *
 * @returns Node[] [div.g-page, ..., a.link]
 *
 * @throws Error
 */
export const getTargetNodes = (eventPathNodes) => {
    if(!eventPathNodes.length) {
        throw new Error(EMPTY_ARRAY_MSG);
    }
    // splice mutates data. Made shallow copy
    const eventPathNodesForMutations = [...eventPathNodes];
    // cut out `Window`, `#document`, `html`, `body` nodes
    eventPathNodesForMutations.reverse().splice(0, 4);

    return eventPathNodesForMutations;
};

/**
 * @param newsNodes NodeList [<tr>...</tr>]
 * @param fieldNodes Node[] [tr, td, a]
 *
 * @returns Number
 *
 * @throws Error
 */
export const getNewsCount = (newsNodes, fieldNodes) => {
    const fieldNodeAndChildNodesCssSelector = getCssSelectorWithPositionsByNodes([
        ...fieldNodes,
        ...getAllChild(fieldNodes[fieldNodes.length - 1]),
    ]);
    const parent = fieldNodes[0].parentNode;
    const cssSelector = parent.parentNode.tagName + ' > ' + parent.tagName + ' > ' + fieldNodeAndChildNodesCssSelector;

    const index = Array.from(newsNodes).findIndex(function(node) {
        return node === parent.parentNode;
    });

    return newsNodes[index].querySelectorAll(cssSelector).length;
};

/**
 * @param node Node <a class="link" ...>...<div>...</div>...</a>
 *
 * @returns Node[] [..., div, ...]
 */
export const getAllChild = (node) => {
    let allChild = [];
    let child = node.firstElementChild;

    while(child) {
        if('NOBR' === child.tagName) {
            child = node.nextSibling;

            continue;
        }

        allChild.push(child);

        child = child.firstElementChild;
    }

    return allChild;
};

/**
 * @param nodes Node[] [div.g-page, , ..., a.topic-link]
 *
 * @returns String 'div.g-page:nth-child(1) > ... > a.link:nth-child(2)'
 *
 * @throws Error
 */
export const getCssSelectorWithPositionsByNodes = (nodes, isContainer) => {
    if(!nodes.length || typeof nodes !== 'object') {
        throw new Error(EMPTY_ARRAY_MSG);
    }
    let cssSelectors;
    //Skipping first 3 elements from the start for container path
    if(isContainer) {
        let counter = 0;
        cssSelectors = nodes.map((node) => {
            if(counter < 3) {
                counter++;
                return node.tagName && node.tagName.toLowerCase();
            } else {
                return node.tagName && nodeToCssSelectorWithPosition(node);
            }
        });
    } else {
        cssSelectors = nodes.map((node) => node.tagName && nodeToCssSelectorWithPosition(node));
    }

    if(!cssSelectors.length) {
        throw new Error(EMPTY_ARRAY_MSG);
    }

    return cssSelectors.filter(selector => typeof selector !== 'undefined').join(' > ');
};

/**
 * @param node Node <ul id="fp-articles_recent" class="l-articles" ...>...</ul>
 *
 * @returns String 'ul.l-articles:nth-child(2)'
 *
 * @throws Error
 */
export const nodeToCssSelectorWithPosition = (node) => {
    try {
        return node.tagName.toLowerCase() + ':nth-child(' + findNodePosition(node) + ')';
    } catch(e) {
        console.log(e);

        throw new Error('Invalid argument.');
    }
};

/**
 * @param node Node <div>...</div>
 *
 * @returns Number
 */
export const findNodePosition = (node) => {
    let index = 1;
    let prevNode = node.previousSibling;

    while(prevNode) {
        if(typeof prevNode.tagName !== 'undefined') {
            index++;
        }

        prevNode = prevNode.previousSibling;
    }

    return index;
};

/**
 * @param path String div.g-page:nth-child(1) > ... > li:nth-child(1)
 *
 * @returns String div.g-page:nth-child(1) > ... > li
 */
export const clearPositionOfLastElement = (path) => {
    return path.replace(/(.*)([^\s+>\s+]+):nth-child\(\d+\)$/g, '$1$2');
};

/**
 * @param pathToContainer String 'div.g-page:nth-child(1) > ... > li:nth-child(1)'
 * @param eventPathNodes Node[] [a.link, ..., document, Window]
 *
 * @returns String 'a.link:nth-child(2)'
 *
 * @throws Error
 */
export const getTargetNodeCssSelector = (pathToContainer, eventPathNodes) => {
    return getCssSelectorWithPositionsByNodes(getTargetNodes(eventPathNodes), true).replace(pathToContainer + ' > ', '');
};

/**
 * @returns Number
 */
export const getColumnCount = () => {
    return COLUMN_COUNT;
};


/**
 * @param pathToContainer  String 'div.g-page:nth-child(1) > ... > li:nth-child(1)'
 * @param pathToElement String 'a.link:nth-child(2)'
 * @param bodyFromIframe Node <body>...</body>
 * @param style String 'lightpink'
 *
 * @throws Error
 */
export const setBackgroundOLD = (pathToContainer, pathToElement, bodyFromIframe, style) => {
    try {
        const containerNode = bodyFromIframe.querySelector(pathToContainer);

        if(!containerNode) {
            throw new Error(BAD_CONTAINER_PATH_MSG);
        }

        const isRow = 'TR' === containerNode.tagName;
        COLUMN_COUNT = isRow ? containerNode.childNodes.length : 0;

        let cssSelectorToContainer = clearPositionOfLastElement(pathToContainer);
        if(isRow) {
            cssSelectorToContainer = clearTablePosition(cssSelectorToContainer);
        }

        bodyFromIframe.querySelectorAll(cssSelectorToContainer).forEach((news) => {
            for(let element of news.querySelectorAll(pathToElement)) {
                if(element.textContent && '' !== element.textContent) {
                    if(isRow) {
                        if(COLUMN_COUNT === news.childNodes.length) {
                            element.style.background = style;
                        }
                    } else {
                        element.style.background = style;
                    }
                }
            }
        });
    } catch(err) {
        console.log('setBackground error: ', err);
    }
};

/**
 * @param path String 'div.pageContent:nth-child(4) > table.regulatoryTable:nth-child(5) > tbody:nth-child(1) > tr'
 *
 * @returns String div.pageContent:nth-child(4) > table.regulatoryTable > tbody:nth-child(1) > tr
 */
export const clearTablePosition = (path) => {
    let pathParts = path.split(' > ');

    pathParts = pathParts.map(function(part) {
        return part.replace(/(table):nth-child\(\d+\)/g, '$1');
    });

    return pathParts.join(' > ');
};

/**
 * @param targetNode Node <td>...</td>
 */
export const setLeaveStyle = (targetNode) => {
    targetNode.style.outline = 'none';
    targetNode.style.cursor = 'pointer';
};

/**
 * @param targetNode Node <td>...</td>
 */
export const setEnterStyle = (targetNode) => {
    targetNode.style.outline = '3px solid lightblue';
    targetNode.style.cursor = 'pointer';
};

/**
 * @param pathToContainer String 'div.g-page:nth-child(1) > ... > li:nth-child(1)'
 * @param targetPath String 'a.link:nth-child(2)'
 * @param bodyFromIframe Node <body>...</body>
 *
 * @returns String 'a.link:nth-child(2)'
 *
 * @throws Error
 */
export const searchLinkPath = (pathToContainer, targetPath, bodyFromIframe) => {
    //const containerNode = bodyFromIframe.querySelector(pathToContainer);
    //const targetNode = containerNode.querySelector(targetPath);
    // console.log(pathToContainer);
    const container = bodyFromIframe.querySelector(pathToContainer);
    // console.log(container);
    // console.log(targetPath);
    let linkPath = '';
    if(container && container.href) {
        linkPath = pathToContainer;
    } else {
        const targetNode = bodyFromIframe.querySelector(pathToContainer + ' > ' + targetPath);
        // console.log(targetNode);
        // console.log('link pathToContainer: ', pathToContainer + ' > ' + targetPath);
        // console.log('link targetNode: ', targetNode);
        if(targetNode) {
            linkPath = findLinkPathInTargetNode(targetNode, targetPath);
            // console.log(linkPath)
            if('' === linkPath) {
                linkPath = findLinkPathInChildNodes(targetNode, targetPath);
                // console.log(linkPath)
            }
            if('' === linkPath) {
                linkPath = findLinkPathInParent(targetNode, targetPath);
                // console.log(linkPath)
            }
            if('' === linkPath) {
                linkPath = findLinkPathInCurrentLevel(targetNode, targetPath);
                // console.log(linkPath)
            }
        }

    }
    // console.log('LINK PATH');
    // console.log(linkPath);
    return linkPath;
};

/**
 * @param targetNode Element <td>...</td>
 * @param targetPath String 'td:nth-child(3)'
 *
 * @returns String 'td:nth-child(3) > a'
 *
 * @throws Error
 */
export const findLinkPathInTargetNode = (targetNode, targetPath) => {
    let linkPath = '';
    if(typeof targetNode !== 'object') {
        throw new Error('Invalid argument');
    }

    if(targetNode.href) {
        // console.log(targetNode)
        // console.log(targetPath)
        let beforeTarget = targetPath.split(' > ');
        let lastNode = beforeTarget[beforeTarget.length - 1]
        // console.log(lastNode)
        // console.log(beforeTarget)
        beforeTarget.splice(-1, 1);
        // console.log(beforeTarget)
        if(beforeTarget.length) {
            // linkPath = beforeTarget.join(' > ') + ' > ' + nodeToCssSelectorWithPosition(targetNode);
            linkPath = beforeTarget.join(' > ') + ' > ' + lastNode;
        } else {
            // linkPath = nodeToCssSelectorWithPosition(targetNode);
            linkPath = targetPath;
        }
    }

    return linkPath;
};

/**
 * @param targetNode Element <td>...</td>
 * @param targetPath String 'td:nth-child(3)'
 *
 * @returns String 'td:nth-child(3) > a'
 *
 * @throws Error
 */
export const findLinkPathInChildNodes = (targetNode, targetPath) => {
    if(typeof targetNode !== 'object') {
        throw new Error('Invalid argument');
    }

    let linkPath = '';
    let linkChildNodes = [];
    let allChild = targetNode.children;

    if(allChild.length) {
        let step = 0;

        while(allChild.length > step && 3 > step) {
            if(allChild[step].href) {
                linkChildNodes.push(allChild[step]);

                break;
            }

            ++step;
        }
    }

    if(linkChildNodes.length) {
        linkPath = targetPath + ' > ' + getCssSelectorWithPositionsByNodes(linkChildNodes);
    }

    return linkPath;
};

/**
 * @param targetNode Element <td>...</td>
 * @param targetPath String 'td:nth-child(3)'
 *
 * @returns String 'td:nth-child(3) > a'
 *
 * @throws Error
 */
export const findLinkPathInParent = (targetNode, targetPath) => {
    if(typeof targetNode !== 'object') {
        throw new Error('Invalid argument');
    }

    // console.log(targetPath);

    let linkPath = '';
    const cssSelectors = targetPath.split(' > ').reverse();
    const countCssSelectors = cssSelectors.length;
    // console.log(cssSelectors);
    let parentNumber = 0;
    while(parentNumber < countCssSelectors) {
        ++parentNumber;

        // TODO: need refactoring this statement
        if(/^a:|^a\.|^a#|^a$/g.test(cssSelectors[parentNumber])) {
            linkPath = cssSelectors.splice(parentNumber, countCssSelectors - parentNumber).reverse().join(' > ');

            break;
        }
    }

    return linkPath;
};

/**
 * @param targetNode Node <b>...</b>
 * @param targetPath String 'td:nth-child(3) > b.blue'
 *
 * @returns String 'td:nth-child(3) > a'
 *
 * @throws Error
 */
export const findLinkPathInCurrentLevel = (targetNode, targetPath) => {
    if(typeof targetNode !== 'object') {
        throw new Error('Invalid argument');
    }

    let linkPath = '';

    let sibling = targetNode.nextSibling;
    while(sibling) {
        if(sibling.href) {
            let beforeTarget = targetPath.split(' > ');
            beforeTarget.splice(-1, 1);

            if(beforeTarget.length) {
                linkPath = beforeTarget + ' > ' + nodeToCssSelectorWithPosition(sibling);
            } else {
                linkPath = nodeToCssSelectorWithPosition(sibling);
            }

            break;
        } else {
            sibling = sibling.nextSibling;
        }
    }

    return linkPath;
};

/**
 * @param pathToContainer  String 'div.g-page:nth-child(1) > ... > li:nth-child(1)'
 * @param pathToElement String 'a.link:nth-child(2)'
 * @param bodyFromIframe Node <body>...</body>
 * @param activeFilter String 'Title'
 *
 * @throws Error
 */
export const highlight = (pathToContainer, pathToElement, bodyFromIframe, activeFilter, selectionType) => {
    if(selectionType === '1') {
        setBackground(pathToContainer, pathToElement, bodyFromIframe, ELEMENT_COLORS[activeFilter]);
    } else if(selectionType === '2') {
        setBackgroundOLD(pathToContainer, pathToElement, bodyFromIframe, ELEMENT_COLORS[activeFilter]);
    }
};

/**
 * @param pathToContainer  String 'div.g-page:nth-child(1) > ... > li:nth-child(1)'
 * @param pathToElement String 'a.link:nth-child(2)'
 * @param bodyFromIframe Node <body>...</body>
 */
export const clearStyle = (pathToContainer, pathToElement, bodyFromIframe, selectionType) => {
    if(selectionType === '1') {
        setBackground(pathToContainer, pathToElement, bodyFromIframe, 'none');
    } else if(selectionType === '2') {
        setBackgroundOLD(pathToContainer, pathToElement, bodyFromIframe, 'none');
    }
};

export const setBackground = (pathToContainer, pathToElement, bodyFromIframe, style) => {
    try {
        bodyFromIframe.querySelectorAll(pathToContainer + ' > ' + pathToElement).forEach((element) => {
            if(element.textContent && element.textContent !== '') {
                element.style.background = style;
            }
        });
    } catch(err) {
        console.log('setBackground error: ', err);
    }
};

function getMaxNumberOfChildren(targetElement) {
    let maxNewsCount = 0;
    for(let currentElement = targetElement; currentElement;) {
        let elementTagName = currentElement.tagName.toLowerCase();
        if(!elementTagName || elementTagName === 'body' || elementTagName === 'html') {
            break;
        }

        if(maxNewsCount < currentElement.childElementCount) {
            maxNewsCount = currentElement.childElementCount;
        }

        currentElement = currentElement.parentNode;
    }

    return maxNewsCount;
};

export const getNewContainerPath = (targetElement, bodyFromIframe, eventPathNodes, fullPath) => {
    if('IMG' === targetElement.tagName) {
        throw new Error(CANNOT_SELECT_IMG_MSG);
    }

    const maxNewsCount = getMaxNumberOfChildren(targetElement);

    for(let currentElement = targetElement; currentElement;) {
        let elementTagName = currentElement.tagName.toLowerCase();
        if(!elementTagName || elementTagName === 'body' || elementTagName === 'html') {
            break;
        }

        //console.log('news container path: ', test(eventPathNodes, bodyFromIframe));

        if(maxNewsCount === currentElement.childElementCount) {
            return test(eventPathNodes, bodyFromIframe, fullPath);
            //return getPathWithClasses(currentElement);
        }

        currentElement = currentElement.parentNode;
    }
};

export const getPathWithClasses = (element, forContainerPath) => {
    let pathToElement = '';
    let currentElement = element;

    // If element has a non-unique className and is in the same level as siblings with the same className, set a
    // value for index which will be used as nth-child to replace the className
    let index;
    let siblingArray = element.parentElement.children;
    if(siblingArray.length > 1 && element.classList.length > 0 && !forContainerPath) {
        let tempIndex = [...element.parentElement.children].indexOf(element);
        if((siblingArray.item(tempIndex - 1) && siblingArray.item(tempIndex - 1).classList.value === element.classList.value) ||
        (siblingArray.item(tempIndex + 1) && siblingArray.item(tempIndex + 1).classList.value === element.classList.value)) {
            index = tempIndex;
        }
    }
    // if(element.classList.contains('important-notice__td')) {
    //     index = [...element.parentElement.children].indexOf(element);
    // }

    //iterate until element isn't body or html
    for(let tempTagName = currentElement.tagName.toLowerCase(); tempTagName;) {
        let elementTagName = currentElement.tagName.toLowerCase();
        if(!elementTagName || elementTagName === 'body' || elementTagName === 'html') {
            //throw new Error('Incorrect element selected');
            break;
        }

        //if element don't have id elementId === ''
        let elementId = currentElement.id;
        //checks if element id is exists. if it have numbers than clear elementId
        if(elementId && isStrHasNumber(elementId)) {
            elementId = '';
        }

        //if element don't have classes elementFirstClass === []
        let elementFirstClass = currentElement.className.split(' ', 1)[0];
        //checks if element is correct tag and if className is not dynamic and dont have numbers
        if(elementFirstClass !== '') { // /(td|tr|ol|ul|li)/i.test(elementTagName))
            // console.log(elementFirstClass)
            let containsValidClassSyntax = /^[a-z_-][a-z\d_-]*$/i;
            // console.log(containsValidClassSyntax.test(elementFirstClass));
            if((isStrHasNumber(elementFirstClass) || isClassNameDynamic(elementFirstClass)) || /(td)/i.test(elementTagName) || elementFirstClass === 'no-after_before' || !containsValidClassSyntax.test(elementFirstClass)) {
                elementFirstClass = '';
            }
        }

        /*
        //gets NodeList of element's attributes. if element do not have attrs elementAttrsArr === []
        let elementAttrsArr = currentElement.attributes;
        let elementStyleAttr = '';
        //find attr 'style' with a textContent and add peace of content(everithing to the fist space) with prefix search 
        if(elementAttrsArr.length > 0 && elementAttrsArr.style && elementAttrsArr.style.nodeName === "style" && elementAttrsArr.style.textContent) {
            elementStyleAttr = `[style^="${elementAttrsArr.style.textContent.substring(0, elementAttrsArr.style.textContent.indexOf(' '))}"]`;
        }
        */

        tempTagName = elementTagName;
        //if element has correct id just adding it, cuz id is unique
        if(elementId) {
            tempTagName += '#' + elementId;
        } else {
            //if element don't have id but have class adds it to path. if element dont have class but have style attr with value- add it to path
            if(elementFirstClass !== '') {
                if(element.className === 'important-notice__td hidden') {
                    // const index = [...element.parentElement.children].indexOf(element);
                    // tempTagName += ':nth-child(' + (index + 1) + ')';

                    tempTagName += '.' + elementFirstClass;

                } else {
                    tempTagName += '.' + elementFirstClass;
                }
            } else if(elementTagName === 'td' && !isNaN(element.cellIndex) && currentElement === element) {
                tempTagName += ':nth-child(' + (element.cellIndex + 1) + ')';
            } else if(elementTagName === 'p' && !element.className) {
                const index = [...element.parentElement.children].indexOf(element);
                tempTagName += ':nth-child(' + (index + 1) + ')';
            }

            /*else if(elementStyleAttr !== '') {
                tempTagName += elementStyleAttr;
            }*/

            //logic for selecting full table row
            /*if(i !== 0 && elementTagName !== 'td' || isNaN(element.cellIndex)) {
                if(elementFirstClass !== '') {
                    tempTagName += "." + escapeAttributeValue(elementFirstClass);
                }
            } else {
                if(window.confirm("Selection seems to be a table cell. Press OK to select table rows or CANCEL to select the column.")) {
                    tempTagName = "";
                } else {
                    tempTagName += ":nth-child(" + (element.cellIndex + 1) + ")";
                }
            }*/
        }
        //Adding peace to the path
        pathToElement = tempTagName + (pathToElement ? ' ' + pathToElement : '');
        //move current element to the higher level
        currentElement = currentElement.parentNode;
        // console.log(currentElement)

    }

    if(index) {
        let lastIndex = pathToElement.lastIndexOf('.')
        let classToReplace = pathToElement.substr(lastIndex, pathToElement.length)
        let replacedClassWithIndex = pathToElement.replace(classToReplace, `:nth-child(${index + 1})`);
        return replacedClassWithIndex.replace(/ /g, ' > ');
    } else {
        return pathToElement.replace(/ /g, ' > ');
    }
    // return pathToElement.replace(/ /g, ' > ');
};

function isStrHasNumber(str) {
    return /\d/.test(str);
}

function isClassNameDynamic(str) {
    return /(odd|even)/i.test(str);
}

export const test = (eventPathNodes, bodyFromIframe, fullPath) => {
    const targetNodes = getTargetNodes(eventPathNodes);
    let targetNode = [...targetNodes].splice(-1, 1)[0];

    if('IMG' === targetNode.tagName) {
        throw new Error(CANNOT_SELECT_IMG_MSG);
    }

    const maxNewsCount = getMaxNewsCount(targetNodes, bodyFromIframe);

    let currentLevel = 0;
    while(20 > currentLevel) {
        ++currentLevel;

        let nodes = [...targetNodes];
        const fieldNodes = nodes.splice(-currentLevel, currentLevel);
        nodes.splice(-1, 1);

        if(!nodes.length || !fieldNodes.length) {
            break;
        }
        const cssSelector = getCssSelectorWithPositionsByNodes(nodes);
        const clearingCssSelector = clearPositionOfLastElement(cssSelector);
        const newsNodeList = bodyFromIframe.querySelectorAll(clearingCssSelector);
        if(!newsNodeList.length) {
            throw new Error(NOT_NEWS_MSG);
        }

        if(maxNewsCount === getNewsCount(newsNodeList, fieldNodes)) {
            if('TR' === fieldNodes[0].parentNode.parentNode.tagName) {  //kostil?
                continue;
            }
            //This var is probably the same as fieldNodes
            let newsNodeList = [...targetNodes];
            newsNodeList.splice(-currentLevel, currentLevel);


            //console.log('newsNodeList: ', newsNodeList);
            //let fullPathNodeList = bodyFromIframe.querySelectorAll(fullPath);
            //let contPath = getPathWithClasses(newsNodeList[newsNodeList.length - 1]);
            //console.log('contPath: ', contPath);
            //let contPathNodeList = bodyFromIframe.querySelectorAll(contPath);
            //let contPathNodeListLength = 0;
            //let pathToTargetNode = fullPath.replace(contPath + ' > ', '');
            // if(contPathNodeList.length === 1) {
            //     console.log('---------------')
            //     if(contPathNodeList[0].querySelectorAll(pathToTargetNode).length === fullPathNodeList.length) {
            //         contPathNodeListLength = fullPathNodeList.length;
            //     }
            //     console.log('---------------')
            // } else {
            //     console.log('contPathNodeList: ', contPathNodeList);
            //     contPathNodeList.forEach(node => {
            //         //console.log('pathToTarget From Container: ', node.querySelector(pathToTargetNode));
            //         if(node.querySelector(pathToTargetNode)) {
            //             contPathNodeListLength++;
            //         }
            //     })
            // }

            //console.log('fullPath test: ', fullPathNodeList);
            //console.log('container path test: ', contPathNodeListLength);

            // if(fullPathNodeList.length !== contPathNodeListLength) {
            //     let newContPathStr = getPathWithClasses(newsNodeList[newsNodeList.length - 1]) + ' > ' + contPathNodeList[0].childNodes[0].tagName.toLowerCase();
            //     console.log('newContPathStr: ', newContPathStr);
            //     contPathNodeList = bodyFromIframe.querySelectorAll(newContPathStr);
            //     console.log('MEW contPathNodeList: ', contPathNodeList);
            //     console.log('contPathNodeList length is ok? ', contPathNodeList.length === fullPathNodeList.length);
            //     return newContPathStr;
            // } else {
            return getPathWithClasses(newsNodeList[newsNodeList.length - 1], true);
            //}
        }
    }

    throw new Error(NOT_NEWS_MSG);
};

export const test1 = (nodes) => {
    if(!nodes.length || typeof nodes !== 'object') {
        throw new Error(EMPTY_ARRAY_MSG);
    }

    let cssSelectors = nodes.map((node) => {
        let elementTagName = node.tagName.toLowerCase();
        let elementFirstClass = node.className.split(' ', 1)[0];
        if(elementFirstClass !== '') {
            if((isStrHasNumber(elementFirstClass) || isClassNameDynamic(elementFirstClass)) || /(td)/i.test(elementTagName)) {
                elementFirstClass = '';
            }
        }
        if(node.tagName) {
            if(elementFirstClass !== '') {
                return elementTagName + '.' + elementFirstClass;
            } else {
                return elementTagName;
            }
        }
    });

    if(!cssSelectors.length) {
        throw new Error(EMPTY_ARRAY_MSG);
    }

    return cssSelectors.filter(selector => typeof selector !== 'undefined').join(' > ');
};